/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import { Card, Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./confirm-decisions.scss";
import {
  pensionWiseGuidanceCompletionContent,
  RA_STEPS_IDENTIFIERS,
} from "../../constants/constants";
import SuccessTick from "../../assets/svg-icons/success-tick.svg";
import download from "../../assets/svg-icons/download.svg";
import { Icons } from "../../atoms/Icons";
import { useDispatch, useSelector } from "react-redux";
import generatePDF from "react-to-pdf";
import { addCommas } from "../../helpers/helpers";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";

const ConfirmDecisions = (props) => {
  const {
    chooseRetirementSteps,
    choose,
    data,
    bankDetails,
    guide,
    confirm,
    moneyinonego,
    taxfreecash,
    moneyinchunk,
    annuitychoice,
    regularchoice,
    mixmatchchoice,
  } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const {
    illustrationFetching,
    illustrationData,
    illustrationError,
  } = // eslint-disable-line
    useSelector(
      (state) => state.viewIllustration // eslint-disable-line
    );
  const dispatch = useDispatch();
  const { getIllustrationContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );
  const choiceCategory = data?.choiceCategory;
  const targetRef = useRef();

  const applicationPotsSelected =
    data?.applicationPots?.length > 0
      ? data?.applicationPots
      : JSON.parse(localStorage.getItem("applicationPots"));

  const potSelectionData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;

  const potUsedOfTotalIndividualPotTakeAllInOneGo =
    potSelectionData?.monetaryChosenAmount /
    potSelectionData?.monetaryActualAmount;

  const potUsedOfTotalIndividualPotMoneyInChunks =
    moneyinchunk?.lumpSumAmt / potSelectionData?.monetaryChosenAmount;

  const mixMatchSelectedPercentage = mixmatchchoice?.cashLumpsum?.percentage;

  const mmTaxFree =
    mixMatchSelectedPercentage > 25
      ? (25 * potSelectionData?.monetaryChosenAmount) / 100
      : (mixMatchSelectedPercentage * potSelectionData?.monetaryChosenAmount) /
        100;

  const mmTaxable =
    mixMatchSelectedPercentage > 25
      ? ((mixMatchSelectedPercentage - 25) *
          potSelectionData?.monetaryChosenAmount) /
        100
      : 0;

  const mmTaxFreeIndividualPercentage =
    mmTaxFree / potSelectionData?.monetaryChosenAmount; //eslint-disable-line

  const mmTaxableIndividualPercentage =
    mmTaxable / potSelectionData?.monetaryChosenAmount; //eslint-disable-line

  const mmMoveToDrawdownIndividualPotPercentage =
    mixmatchchoice?.cashLumpsum?.amount /
    potSelectionData?.monetaryChosenAmount;

  const mixAndMatch =
    Object.keys(mixmatchchoice).length > 0 ? mixmatchchoice : 0; //eslint-disable-line
  const regularIncome =
    Object.keys(regularchoice).length > 0 ? regularchoice : 0; //eslint-disable-line
  const investRest = Object.keys(taxfreecash).length > 0 ? taxfreecash : 0; //eslint-disable-line
  const investRestLegacyAmt = investRest?.investTheRest?.investRestLegacyAmt
    ? investRest?.investTheRest?.investRestLegacyAmt
    : 0;
  const investRestSafetNetAmt = investRest?.investTheRest?.investRestSafetNetAmt
    ? investRest?.investTheRest?.investRestSafetNetAmt
    : 0;
  const totalIncomeTaxFreeCash =
    investRest?.investTheRest?.investRestFlexiAccessTotalValue +
    investRestLegacyAmt + //eslint-disable-line
    investRestSafetNetAmt; //eslint-disable-line
  const regularChoicePercentage = regularIncome?.percentage;
  const totalIncomeMixMatch =
    mixAndMatch?.investTheRest?.annuityAmount +
    mixAndMatch?.investTheRest?.faAmount +
    mixAndMatch?.investTheRest?.faiCurrentIncome +
    mixAndMatch?.investTheRest?.miCurrentIncome +
    mixAndMatch?.cashLumpsum?.amount *
      mixAndMatch?.investTheRest?.legacyPercent +
    mixAndMatch?.cashLumpsum?.amount *
      mixAndMatch?.investTheRest?.safetynetPercent;
  const totalIncomeRegularIncome =
    regularIncome?.faAmount +
    regularIncome?.miCurrentIncome +
    regularIncome?.faiCurrentIncome; //eslint-disable-line
  const mixAndMatchInvestTheRest = mixAndMatch?.investTheRest;
  const handleIllustration = (item) => {
    const payload = {
      investorId: props.investorId,
      investorAccountId: Number(item?.potId),
      incomeFrequency: 12,
      targetTfcPercentage:
        regularIncome != 0
          ? regularChoicePercentage?.toString()
          : mixAndMatch != 0
            ? mixAndMatch?.cashLumpsum?.percentage.toString()
            : investRest != 0
              ? investRest?.percenateLumpsum?.toString()
              : "",
      // incomeAmount: totalIncomeRegularIncome.toString(),
      incomeAmount:
        regularIncome != 0
          ? totalIncomeRegularIncome.toString()
          : mixAndMatch != 0
            ? totalIncomeMixMatch.toString()
            : investRest != 0
              ? totalIncomeTaxFreeCash.toString()
              : "",
      pensionSavingMem: item?.potId.toString(),
      totalBalance: parseFloat(item?.potValue),
      taxFreeCash:
        regularIncome != 0
          ? item?.potMonetaryAmount * (regularChoicePercentage / 100) //eslint-disable-line
          : mixAndMatch != 0
            ? mmTaxFree
            : investRest != 0
              ? investRest.taxFreeCash
              : "",
      taxableLumpSums:
        regularIncome != 0
          ? item?.potValue -
            item?.potMonetaryAmount * //eslint-disable-line
              (regularChoicePercentage / 100) //eslint-disable-line
          : mixAndMatch != 0
            ? mmTaxable
            : investRest != 0
              ? investRest.movingToDrawDown - investRest.taxFreeCash
              : "",
      taxablePensionSavings:
        regularIncome != 0
          ? parseFloat(
              regularchoice?.riData?.movingToDrawdown.replace(/,/g, "") //eslint-disable-line
            )
          : mixAndMatch != 0
            ? mixAndMatch?.cashLumpsum?.amount
            : investRest != 0
              ? investRest.movingToDrawDown
              : "",

      requestedInvestment: [
        {
          managedIncome: {
            fundid: data?.applicationPots[0]?.managedIncomeFundId,
            fundValue:
              regularIncome != 0
                ? parseFloat(regularIncome?.miAmount)
                : mixAndMatch != 0
                  ? mixAndMatchInvestTheRest?.miCurrentIncome
                  : investRest != 0
                    ? "0"
                    : "",
          },
          futureAnnuity: {
            fundid: data?.applicationPots[0]?.futureAnnuityFundId,
            fundValue:
              regularIncome != 0
                ? parseFloat(
                    regularIncome?.faIncomeAmount //eslint-disable-line
                  ) //eslint-disable-line
                : mixAndMatch != 0
                  ? parseFloat(
                      mixAndMatchInvestTheRest?.faiCurrentIncome //eslint-disable-line
                    )
                  : investRest != 0
                    ? "0"
                    : "",
          },

          flexiAccess: {
            fundValue:
              regularIncome != 0
                ? parseFloat(regularIncome?.faAmount)
                : mixAndMatch != 0
                  ? parseFloat(
                      mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
                    )
                  : investRest != 0
                    ? investRest?.investTheRest?.investRestFlexiAccessTotalValue
                    : "",
          },
          safetyNet: {
            fundid: data?.applicationPots[0]?.legacyFundId,
            fundValue:
              regularIncome != 0
                ? 0
                : mixAndMatch != 0
                  ? Number(
                      (
                        (parseFloat(mixAndMatch?.cashLumpsum?.amount || 0) *
                          (mixAndMatchInvestTheRest?.safetynetPercent || 0)) /
                        100
                      ).toFixed(2),
                    )
                  : investRest != 0
                    ? Number(
                        (
                          investRest?.investTheRest?.investRestSafetNetAmt || 0
                        ).toFixed(2),
                      )
                    : 0,
          },

          legacy: {
            fundid: data?.applicationPots[0]?.legacyFundId,
            fundValue:
              regularIncome != 0
                ? 0
                : mixAndMatch != 0
                  ? Number(
                      (
                        (parseFloat(mixAndMatch?.cashLumpsum?.amount || 0) *
                          (mixAndMatchInvestTheRest?.legacyPercent || 0)) /
                        100
                      ).toFixed(2),
                    )
                  : investRest != 0
                    ? Number(
                        (
                          investRest?.investTheRest?.investRestLegacyAmt || 0
                        ).toFixed(2),
                      )
                    : 0,
          },
        },
      ],
      managedIncomePaymentPerMonth:
        regularIncome != 0
          ? regularIncome?.miCurrentIncome?.toString()
          : mixAndMatch != 0
            ? mixAndMatchInvestTheRest?.miCurrentIncome.toString()
            : investRest != 0
              ? "0"
              : "",
      futureAnnuityIncomePaymentPerMonth:
        regularIncome != 0
          ? regularIncome?.faiCurrentIncome?.toString()
          : mixAndMatch != 0
            ? (
                parseFloat(
                  mixAndMatchInvestTheRest?.faiCurrentIncome //eslint-disable-line
                ) / 12
              ).toString()
            : investRest != 0
              ? "0"
              : "",
      futureFlexiAccessPaymentAmount:
        regularIncome != 0
          ? regularIncome?.faChoosenAmount?.toString()
          : mixAndMatch != 0
            ? (
                parseFloat(
                  mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
                ) / 12
              ).toString()
            : investRest != 0
              ? (
                  investRest?.investTheRest?.investRestFlexiAccessTotalValue /
                  12
                ).toString()
              : "",
      flexiAccessIncomePaymentFrequency:
        regularIncome != 0
          ? regularIncome?.faFequency?.toString()
          : mixAndMatch != 0
            ? mixAndMatchInvestTheRest?.faFequency.toString()
            : investRest != 0
              ? "Monthly"
              : "",
      totalRegularIncome:
        regularIncome != 0
          ? totalIncomeRegularIncome?.toString()
          : mixAndMatch != 0
            ? totalIncomeMixMatch?.toString()
            : investRest != 0
              ? totalIncomeTaxFreeCash.toString()
              : "",
      retirementId: props.retirementId ? props.retirementId : 0,
    };
    handleIllustrationClick(payload);
    props.illutrationOpened.current = true;
  };
  const handleIllustrationClick = async (payload) => {
    try {
      const result = await getIllustrationContent(payload);
      const base64String = result?.encodedPdf;

      if (!base64String) {
        alert("Document content not found.");
        return;
      }

      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error opening document:", error);
      alert("Failed to open document.");
    }
  };

  const valueCorrectedAsOverlay = () => {
    return (
      <OverlayTrigger
        placement="right"
        overlay={
          <Popover id="popover-contained" className="tooltip-popover-section">
            <Popover.Body className="tooltip-popover-body">
              <p>
                All the values are estimates, based on the most accurate
                information available. They include all the contributions paid
                by you and your employer.
              </p>
              <p>
                The value of your pension savings is based on current financial
                conditions and is not guaranteed. The amounts you receive may be
                higher or lower than the amounts shown above. Payment of your
                pension will be subject to TPT’s Trust Deed and Rules, and
                regulatory requirements.
              </p>
            </Popover.Body>
          </Popover>
        }
        flip={true}
      >
        <span className="textarea-tooltip">
          <Icons iconname="tool-tip" variant="icon-twelve-px" />
        </span>
      </OverlayTrigger>
    );
  };

  const pensionWiseGuidance = [
    guide?.receivedGuidanceFromPensionWise &&
      pensionWiseGuidanceCompletionContent?.RECEIVED_GUIDANCE_FROM_PENSIONWISE,
    guide?.receivedAdviceFromFCA &&
      pensionWiseGuidanceCompletionContent?.RECEIVED_ADVICE_FROM_FCA,
    guide?.wishToOptOutGuidanceFromPW &&
      pensionWiseGuidanceCompletionContent?.WISH_TO_OPT_OUT_GUIDANCE_FROM_PW,
  ];
  const handleBack = () => {
    props.makeInitialStepper(true);
  };
  const handleContinue = () => {
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.DECLARATION);
  };
  return (
    <>
      <Card className="application-step" ref={targetRef}>
        <Card.Body className="confirm-decisions">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance _title">Confirm your decisions</p>
            </Col>
          </Row>
          <Row className="ourter-bg d-flex justify-content-center">
            <Col md={8}>
              <p>
                Please read all the details you have entered carefully and
                ensure it is all correct before continuing.
              </p>
            </Col>
            <Col md={4}>
              <div className="download-application">
                <img src={download} className="arrowIcon exclude-from-pdf" />
                <Buttons
                  className="tertiary w-auto print-hide hide-for-pdf exclude-from-pdf"
                  name="Download application"
                  handleClick={async () => {
                    const element = targetRef.current;

                    // Wait for canvas rendering
                    const canvas = await html2canvas(element, {
                      scale: 4,
                      useCORS: true,
                      ignoreElements: (el) =>
                        el.classList.contains("exclude-from-pdf"),
                    });

                    const imgData = canvas.toDataURL("image/jpeg", 0.98);

                    const pdfWidth = 480;
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                    const pdf = new jsPDF({
                      orientation: "portrait",
                      unit: "px",
                      format: [pdfWidth, pdfHeight],
                    });

                    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
                    pdf.save("Application.pdf");
                  }}
                  btn2={props.wteBtn}
                />
              </div>
            </Col>
          </Row>
          <div className="block guidance-advice">
            <div className="d-flex justify-content-between">
              <div className="declaration-title">Guidance and advice</div>
              <Buttons
                handleClick={() => {
                  props.setEditingPage("GuidanceAndAdvice");
                  props.makeInitialStepper(false, 0, {
                    isPensionWise: true,
                  });
                }}
                btn2={props.wteBtn}
                className="tertiary w-auto edit-btn exclude-from-pdf"
                name="Edit"
              />
            </div>
            <hr className="hr" />
            <div>
              <div className="decision">
                <div>Selected retirement date:</div>

                {new Intl.DateTimeFormat("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }).format(new Date())}
              </div>
              {confirm?.read && confirm?.warning && (
                <div className="mt-3">
                  <p className="mb-1">
                    I have read important information regarding pension scams,
                    state benefits, combining TPT pots and my right to shop
                    around.
                  </p>
                  <p>
                    I have read the risk warnings with each pension option at{" "}
                    <a
                      className="tpt-links"
                      href="https://tpt.co.uk/risk-warnings"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tpt.co.uk/risk-warnings
                    </a>
                    .
                  </p>
                </div>
              )}
              <div className="decision">
                <div className="pension-wise-guidance">
                  <div className="text-key">Pension Wise guidance:</div>
                  <div className="text-object">
                    {data?.guide?.receivedGuidanceFromPensionWise}
                  </div>
                </div>
              </div>
            </div>
            <hr className="hr" />
            {pensionWiseGuidance?.map((item, index) => {
              return (
                item && (
                  <>
                    <div className="consent-container d-flex mt-1">
                      <img src={SuccessTick} className="arrowIcon" />
                      <div className="ms-2">
                        <li key={index}>{item}</li>
                      </div>
                    </div>
                  </>
                )
              );
            })}
          </div>
          <div className="block">
            <div className="d-flex justify-content-between">
              <div className="declaration-title">Other pensions</div>
              <Buttons
                handleClick={() => {
                  props.setEditingPage("PensionWiseGuidance");
                  props.makeInitialStepper(false, 1, {
                    isLumpSumAllowances: true,
                  });
                }}
                btn2={props.wteBtn}
                className="tertiary w-auto edit-btn exclude-from-pdf"
                name="Edit"
              />
            </div>
            <hr className="hr" />

            <div className="decision">
              The total of my tax-free lump sums is not expected to exceed the
              lump sum allowance.
            </div>
          </div>
          <div className="block">
            <div className="d-flex justify-content-between">
              <div className="declaration-title">Choosing your retirement</div>
              <div className="d-flex ">
                <Buttons
                  handleClick={() => {
                    props.setEditingPage("ChooseYourRetirement");
                    props.makeInitialStepper(false, 2, {
                      isPotSelection: true,
                    });
                  }}
                  btn2={props.wteBtn}
                  className="tertiary w-auto edit-btn ms-4 exclude-from-pdf"
                  name="Edit"
                />
              </div>
            </div>
            <hr className="hr" />

            <div className="cyr-container">
              <>
                {chooseRetirementSteps?.isTakeMoneyInOneGo === true ? (
                  <div className="all-money-in-one-go-confirm">
                    <div>
                      <p className="bold-text">
                        You&apos;ve chosen to take all your money in one go
                      </p>
                    </div>
                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" + addCommas(item.potValue)}
                                </Col>
                              </Row>
                              {potUsedOfTotalIndividualPotTakeAllInOneGo *
                                100 !==
                                100 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Total lump sum taken:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                            <Col>
                              <Row>
                                <Col lg={6} md={6}>
                                  Of which tax-free cash(25%):
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        0.25
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Of which taxable cash:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        0.75
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : chooseRetirementSteps?.isTakeTaxFreeCashInvestRest ===
                  true ? (
                  <div className="tax-free-cash-invest-rest">
                    <div>
                      <p className="bold-text">
                        {taxfreecash?.islumpSum ? (
                          <>
                            You&apos;ve chosen to take tax-free cash and invest
                            the rest in TPT drawdown
                          </>
                        ) : (
                          <>
                            You&apos;ve chosen to take tax-free cash as an
                            income and invest the rest in TPT drawdown
                          </>
                        )}
                      </p>
                    </div>
                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          {" "}
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              {taxfreecash?.islumpSum ? (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Applying with:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Tax-free cash lump sum:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (taxfreecash?.percenateLumpsum /
                                              100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Amount moved to drawdown:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            3 *
                                            item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (taxfreecash?.percenateLumpsum /
                                              100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <Row>
                                  <Col lg={6} md={6}>
                                    Tax-free cash as income:
                                  </Col>
                                  <Col lg={6} md={6} className="bold-text">
                                    {"£" +
                                      addCommas(
                                        (
                                          taxfreecash?.regularIncomeTaxFreeAmount *
                                          ((item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo) /
                                            potSelectionData?.monetaryChosenAmount)
                                        ).toFixed(2) //eslint-disable-line
                                      )}
                                  </Col>
                                </Row>
                              )}
                            </Col>
                            <Col lg={6} md={6}>
                              {taxfreecash?.islumpSum ? (
                                <>
                                  <Row>
                                    <span>TPT drawdown selection:</span>
                                    <Col lg={6} md={6}>
                                      <ul>
                                        {taxfreecash?.investTheRest
                                          ?.investRestFlexiAccessPerc > 0 && (
                                          <li>Flexi-access</li>
                                        )}
                                        {taxfreecash?.investTheRest
                                          ?.investRestsafetyNetPer > 0 && (
                                          <li>Safety net</li>
                                        )}
                                        {taxfreecash?.investTheRest
                                          ?.investRestLegacyPerc > 0 && (
                                          <li>Legacy</li>
                                        )}
                                      </ul>
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <ul>
                                        {taxfreecash?.investTheRest
                                          ?.investRestFlexiAccessPerc > 0 && (
                                          <li className="bold-text">
                                            {taxfreecash?.investTheRest
                                              ?.investRestFlexiAccessPerc + "%"}
                                          </li>
                                        )}
                                        {taxfreecash?.investTheRest
                                          ?.investRestsafetyNetPer > 0 && (
                                          <li className="bold-text">
                                            {taxfreecash?.investTheRest
                                              ?.investRestsafetyNetPer + "%"}
                                          </li>
                                        )}
                                        {taxfreecash?.investTheRest
                                          ?.investRestLegacyPerc > 0 && (
                                          <li className="bold-text">
                                            {taxfreecash?.investTheRest
                                              ?.investRestLegacyPerc + "%"}
                                          </li>
                                        )}
                                      </ul>
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Amount moved to drawdown per
                                      payment(flexi-access):
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            3 *
                                            (taxfreecash?.regularIncomeTaxFreeAmount *
                                              ((item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo) /
                                                potSelectionData?.monetaryChosenAmount))
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Income paid until:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {
                                        taxfreecash?.regularIncomePensionLastDate
                                      }
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                          </Row>
                          {taxfreecash?.islumpSum && (
                            <>
                              {" "}
                              <div className="d-flex justify-content-between">
                                <div>
                                  <div className="value-correct-date">
                                    <span className="me-1">
                                      Values correct as of{" "}
                                      {taxfreecash?.valueCorrectAs}
                                    </span>
                                    {valueCorrectedAsOverlay()}
                                  </div>
                                </div>
                                <a
                                  className="tertiary w-auto download-btn mt-0 mb-0 me-0"
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={() => {
                                    handleIllustration(item);
                                  }}
                                >
                                  {item?.potId + "_Illustration.pdf"}
                                </a>
                                {illustrationFetching ? <LoadingSpinner /> : ""}
                              </div>
                              {illustrationError ? (
                                <NotFound err="Unable to load illustration" />
                              ) : (
                                ""
                              )}
                            </>
                          )}
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : chooseRetirementSteps?.isTakeMoneyInOneChunk === true ? (
                  <div className="money-in-chunk">
                    <div>
                      <p className="bold-text">
                        You&apos;ve chosen to take a lump sum withdrawal from
                        your pension pot
                      </p>
                    </div>
                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {" "}
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount withdrawn:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        potUsedOfTotalIndividualPotMoneyInChunks
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                <Col lg={6} md={6}>
                                  Tax-free cash lump sum(25%):
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        potUsedOfTotalIndividualPotMoneyInChunks *
                                        0.25
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Taxable cash:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        potUsedOfTotalIndividualPotMoneyInChunks *
                                        0.75
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : chooseRetirementSteps?.isRegularHowMuchCash === true ? (
                  <div className="take-regular-income mt-2">
                    <p className="bold-text">
                      You’ve chosen take tax-free cash and regular income from
                      TPT drawdown
                    </p>
                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" + addCommas(item.potValue)}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Applying with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Tax-free cash lump sum:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        (regularchoice?.percentage / 100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              {regularchoice?.miAllocationPercent > 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Amount moved to managed income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.miAllocationPercent /
                                              100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Estimated managed income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.miAllocationPercent /
                                              100) *
                                            (regularchoice?.miCurrentIncome /
                                              regularchoice?.miAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      p/m
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                            <Col>
                              {regularchoice?.faIncomePercentage > 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Amount moved to future annuity income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.faIncomePercentage /
                                              100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Estimated future annuity income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.faIncomePercentage /
                                              100) *
                                            (regularchoice?.faiCurrentIncome /
                                              regularchoice?.faIncomeAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      p/m
                                    </Col>
                                  </Row>
                                </>
                              )}
                              {regularchoice?.faPercent > 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Amount moved to flexi-access
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.faPercent / 100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Flexi-access income
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (regularchoice?.percentage /
                                                  100)) *
                                            (regularchoice?.faPercent / 100) *
                                            (regularchoice?.faChoosenAmount /
                                              regularchoice?.faAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      {regularchoice?.faFequency === "Monthly"
                                        ? "p/m"
                                        : regularchoice?.faFequency ===
                                            "Quarterly"
                                          ? "p/q"
                                          : regularchoice?.faFequency ===
                                              "Half yearly"
                                            ? "p/6m"
                                            : regularchoice?.faFequency ===
                                                "Annually"
                                              ? "p/y"
                                              : ""}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-between">
                            <div>
                              <div className="value-correct-date">
                                <span className="me-1">
                                  Values correct as of{" "}
                                  {regularchoice?.valueCorrectAs}
                                </span>
                                {valueCorrectedAsOverlay()}
                              </div>
                            </div>
                            <a
                              className="tertiary w-auto download-btn mt-0 mb-0 me-0"
                              target="_blank"
                              rel="noreferrer"
                              onClick={() => {
                                handleIllustration(item);
                              }}
                            >
                              {item?.potId + "_Illustration.pdf"}
                            </a>

                            {illustrationFetching ? <LoadingSpinner /> : ""}
                          </div>
                          {illustrationError ? (
                            <NotFound err="Unable to load illustration" />
                          ) : (
                            ""
                          )}
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : chooseRetirementSteps?.isAnnuityHowMuchCash === true ? (
                  <div className="take-guranteed-annuity">
                    <p className="bold-text">
                      You’ve chosen to take tax-free cash and buy an annuity
                    </p>
                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      item.potValue.toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Applying with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                <Col lg={6} md={6}>
                                  Taking tax free:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        (annuitychoice?.cashWithdrawPerc / 100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Buying an annuity with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                        item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo *
                                          (annuitychoice?.cashWithdrawPerc /
                                            100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Annuity provider name
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {annuitychoice?.annuityProvider}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : chooseRetirementSteps?.isMixMatchHowMuchCash === true ? (
                  <div className="mix-match mt-3">
                    <p className="bold-text">You’ve chosen to mix and match</p>

                    <Row>
                      {applicationPotsSelected?.map((item) => (
                        <>
                          <Row className="mb-3">
                            <Col lg={6} md={6}>
                              <Row>
                                <Col lg={6} md={6}>
                                  Retiring with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  <span>
                                    {item.potId}&nbsp;&nbsp;{item.potName}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Your pension pot:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" + addCommas(item.potValue)}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Applying with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Tax-free cash lump sum:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        mmTaxFreeIndividualPercentage *
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to drawdown:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        mmMoveToDrawdownIndividualPotPercentage
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Taxable lump sum:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        mmTaxableIndividualPercentage *
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              {mixmatchchoice?.investTheRest?.annuityPercent >
                                0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Buying an annuity:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            mmMoveToDrawdownIndividualPotPercentage *
                                            (mixmatchchoice?.investTheRest
                                              ?.annuityPercent /
                                              100)
                                          ).toFixed(2) //eslint-disable-line
                                        )}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Annuity provider:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {
                                        mixmatchchoice?.investTheRest
                                          ?.annuityProvider
                                      }
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                            <Col>
                              {mixmatchchoice?.investTheRest?.miPercent > 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Managed income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {mixmatchchoice?.investTheRest
                                        ?.miPercent + "%"}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Estimated income payment:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (mixmatchchoice?.cashLumpsum
                                                  ?.percentage /
                                                  100)) *
                                            (mixmatchchoice?.investTheRest
                                              ?.miPercent /
                                              100) *
                                            (mixmatchchoice?.investTheRest
                                              ?.miCurrentIncome /
                                              mixmatchchoice?.investTheRest
                                                ?.miAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      p/m
                                    </Col>
                                  </Row>{" "}
                                </>
                              )}
                              {mixmatchchoice?.investTheRest?.faiPercent >
                                0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Future annuity income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {mixmatchchoice?.investTheRest
                                        ?.faiPercent + "%"}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Estimated income payment:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (mixmatchchoice?.cashLumpsum
                                                  ?.percentage /
                                                  100)) *
                                            (mixmatchchoice?.investTheRest
                                              ?.faiPercent /
                                              100) *
                                            (mixmatchchoice?.investTheRest
                                              ?.faiCurrentIncome /
                                              mixmatchchoice?.investTheRest
                                                ?.faiAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      p/m
                                    </Col>
                                  </Row>
                                </>
                              )}
                              {mixmatchchoice?.investTheRest?.faPercent > 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Flexi-access:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {mixmatchchoice?.investTheRest
                                        ?.faPercent + "%"}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Flexi-access income:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {"£" +
                                        addCommas(
                                          (
                                            (item.potValue *
                                              potUsedOfTotalIndividualPotTakeAllInOneGo -
                                              item.potValue *
                                                potUsedOfTotalIndividualPotTakeAllInOneGo *
                                                (mixmatchchoice?.cashLumpsum
                                                  ?.percentage /
                                                  100)) *
                                            (mixmatchchoice?.investTheRest
                                              ?.faPercent /
                                              100) *
                                            (mixmatchchoice?.investTheRest
                                              ?.faChoosenAmount /
                                              mixmatchchoice?.investTheRest
                                                ?.faAmount)
                                          ).toFixed(2) //eslint-disable-line
                                        )}{" "}
                                      {mixmatchchoice?.investTheRest
                                        ?.faFequency === "Monthly"
                                        ? "p/m"
                                        : mixmatchchoice?.investTheRest
                                              ?.faFequency === "Quarterly"
                                          ? "p/q"
                                          : mixmatchchoice?.investTheRest
                                                ?.faFequency === "Half yearly"
                                            ? "p/6m"
                                            : mixmatchchoice?.investTheRest
                                                  ?.faFequency === "Annually"
                                              ? "p/y"
                                              : ""}
                                    </Col>
                                  </Row>
                                </>
                              )}
                              {mixmatchchoice?.investTheRest?.safetynetPercent >
                                0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Safety net:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {mixmatchchoice?.investTheRest
                                        ?.safetynetPercent + "%"}
                                    </Col>
                                  </Row>{" "}
                                </>
                              )}
                              {mixmatchchoice?.investTheRest?.legacyPercent >
                                0 && (
                                <>
                                  <Row>
                                    <Col lg={6} md={6}>
                                      Legacy:
                                    </Col>
                                    <Col lg={6} md={6} className="bold-text">
                                      {mixmatchchoice?.investTheRest
                                        ?.legacyPercent + "%"}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-between">
                            <div>
                              <div className="value-correct-date">
                                <span className="me-1">
                                  Values correct as of{" "}
                                  {
                                    mixmatchchoice?.investTheRest
                                      ?.valueCorrectAs
                                  }
                                </span>
                                {valueCorrectedAsOverlay()}
                              </div>
                            </div>
                            <a
                              className="tertiary w-auto download-btn mt-0 mb-0 me-0"
                              target="_blank"
                              rel="noreferrer"
                              onClick={() => {
                                handleIllustration(item);
                              }}
                            >
                              {item?.potId + "_Illustration.pdf"}
                            </a>
                            {illustrationFetching ? <LoadingSpinner /> : ""}
                          </div>
                          {illustrationError ? (
                            <NotFound err="Unable to load illustration" />
                          ) : (
                            ""
                          )}
                          <hr className="hr" />
                        </>
                      ))}
                    </Row>
                  </div>
                ) : (
                  ""
                )}
                {(chooseRetirementSteps?.isTakeMoneyInOneGo ||
                  chooseRetirementSteps?.isTakeMoneyInOneChunk ||
                  chooseRetirementSteps?.isAnnuityHowMuchCash ||
                  (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
                    taxfreecash?.isRegularincome)) && (
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="value-correct-date">
                        <span className="me-1">
                          Values correct as of{" "}
                          {chooseRetirementSteps?.isTakeMoneyInOneChunk
                            ? moneyinchunk?.valueCorrectAs
                            : chooseRetirementSteps?.isTakeMoneyInOneGo
                              ? moneyinonego?.valueCorrectAs
                              : chooseRetirementSteps?.isAnnuityHowMuchCash
                                ? annuitychoice?.valueCorrectAs
                                : chooseRetirementSteps?.isTakeTaxFreeCashInvestRest
                                  ? taxfreecash?.valueCorrectAs
                                  : ""}
                        </span>
                        {valueCorrectedAsOverlay()}
                      </div>
                    </div>
                  </div>
                )}
                {chooseRetirementSteps?.isTakeMoneyInOneGo && (
                  <>
                    <hr className="hr" />
                    {choiceCategory?.declaration?.read && (
                      <div className="consent-container d-flex mb-2">
                        <img src={SuccessTick} className="arrowIcon" />
                        <div className="ms-2">
                          {`I accept that if I am ineligible for a 'Small
                              pots' my lump sum will be paid as an
                              UFPLS (which would trigger the money purchase
                              annual allowance)`}
                        </div>
                      </div>
                    )}
                    {choiceCategory?.declaration?.isControllingDirector && (
                      <div className="consent-container d-flex mb-2">
                        <img src={SuccessTick} className="arrowIcon" />
                        <div className="ms-2">
                          {`I am a controlling director of this scheme or related scheme, or connected to such a person`}
                        </div>
                      </div>
                    )}
                  </>
                )}
                {(chooseRetirementSteps?.isTakeMoneyInOneChunk ||
                  chooseRetirementSteps?.isRegularHowMuchCash) && (
                  <>
                    {chooseRetirementSteps?.isTakeMoneyInOneChunk && (
                      <hr className="hr" />
                    )}
                    {choiceCategory?.declaration?.read && (
                      <div className="consent-container d-flex mb-2">
                        <img src={SuccessTick} className="arrowIcon" />
                        <div className="ms-2">
                          <span className="fw-bold">
                            I have read through all information
                          </span>{" "}
                          provided and am happy to go ahead with the option(s)
                          selected
                        </div>
                      </div>
                    )}
                    {choiceCategory?.declaration?.risk && (
                      <div className="consent-container d-flex mb-2">
                        <img src={SuccessTick} className="arrowIcon" />
                        <div className="ms-2">
                          <>
                            <span className="fw-bold">
                              I have read the risk warnings
                            </span>{" "}
                            associated with my choices and I’m happy to go ahead
                            with the options selected
                          </>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {choiceCategory?.moreContributions && (
                  <>
                    {chooseRetirementSteps?.isMixMatchHowMuchCash ||
                      (chooseRetirementSteps?.isAnnuityHowMuchCash && (
                        <hr className="hr" />
                      ))}
                    <div className="consent-container d-flex mb-2">
                      <img src={SuccessTick} className="arrowIcon" />
                      <div className="ms-2">
                        <>
                          I{" "}
                          {choiceCategory?.yourContribution
                            ?.continueContribution
                            ? "do"
                            : "don't"}{" "}
                          intend to continue contributing to my TPT pension
                        </>
                      </div>
                    </div>
                  </>
                )}
                {(chooseRetirementSteps?.isRegularHowMuchCash ||
                  chooseRetirementSteps?.isMixMatchHowMuchCash ||
                  (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
                    taxfreecash?.islumpSum)) && (
                  <>
                    {!choiceCategory?.moreContributions &&
                      chooseRetirementSteps?.isMixMatchHowMuchCash &&
                      choiceCategory?.moreContributions && (
                        <hr className="hr" />
                      )}
                    <div>
                      {/* TODO- if needed for same implementation as completion screen
                          <p>
                            Ensure that you’re comfortable with your choices and
                            their impact on your pension savings.
                          </p> */}
                      {choiceCategory?.illustration?.terms && (
                        <>
                          <div className="consent-container d-flex">
                            <img src={SuccessTick} className="arrowIcon" />
                            <span className="ms-2">
                              I have read and accept my illustration(s)
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
          <div className="block">
            <div className="d-flex justify-content-between">
              <div className="declaration-title">Bank mandate</div>
              <Buttons
                handleClick={() => {
                  props.setEditingPage("BankMandate");
                  props.makeInitialStepper(false, 3, {
                    isBankMandate: true,
                  });
                }}
                btn2={props.wteBtn}
                className="tertiary w-auto edit-btn exclude-from-pdf"
                name="Edit"
              />
            </div>
            <hr className="hr" />
            {bankDetails?.swift ? (
              <Row className="d-flex justify-content-between">
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>SWIFT: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.swift}
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-between">
                    <div> Account name: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.accountName}
                    </div>
                  </div>
                </Col>
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account Number: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.accountNumber}
                    </div>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="d-flex justify-content-between">
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account name: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.accountName}
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Sort code: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.sortCodeVal}
                    </div>
                  </div>
                </Col>
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account number: </div>
                    <div className="text-object w-auto mx-2">
                      {bankDetails?.accountNumber}
                    </div>
                  </div>
                  {bankDetails?.societyCode && (
                    <div className="d-flex flex-row justify-content-between">
                      <div>Building society code: </div>
                      <div className="text-object w-auto mx-2">
                        {bankDetails?.societyCode}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            )}
            <hr className="hr" />
            {props?.bankMandateConfirmationChecked && (
              <div
                className={`consent-container d-flex ${
                  props?.swiftInfoChecked ? "mb-2" : ""
                }`}
              >
                <img src={SuccessTick} className="arrowIcon" />
                <div className="ms-2">
                  {`I authorise you to pay my pension and any lump sum into the bank or building society shown above`}
                </div>
              </div>
            )}
            {props?.swiftInfoChecked && (
              <div className="consent-container d-flex">
                <img src={SuccessTick} className="arrowIcon" />
                <div className="ms-2">
                  {`I accept that SWIFT payments may incur a bank charge and will be converted at the bank’s exchange rate at the time of payment. Any incorrect or missing information will incur delays and may result in additional costs`}
                </div>
              </div>
            )}
          </div>
          <div className="block">
            <div className="d-flex justify-content-between">
              <div className="declaration-title">
                Identification and verification
              </div>
            </div>
            <hr className="hr" />
            <Row className="mt-2">
              <Col md={8}>
                <div>Thank you for providing your identity documents.</div>
              </Col>
            </Row>
          </div>
          <div className="footer-btn-container">
            <Buttons
              handleClick={() => handleBack()}
              className="secondary back-btn exclude-from-pdf"
              name="Back"
            />

            <Buttons
              handleClick={() => handleContinue()}
              className="primary confirm-btn exclude-from-pdf"
              name="Confirm and continue"
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export default ConfirmDecisions;
